// const { default: zIndex } = require("@material-ui/core/styles/zIndex")

var mainColor = "#fff";
var secondColor = "#f6f6f6";

exports.customTable = function () {
  return {
    typography: {
      useNextVariants: true,
    },
    overrides: {
      MUIDataTable: {
        paper: {
          position: "relative",
          // width: '100% !important',
          boxShadow: "0 0 0 0 rgba(154,161,171,.15)",
          border: "1px rgba(0,0,0,0.1) solid",
          borderRadius: "7.5px",
          overflow: "hidden",
        },
        // responsiveScroll: {
        //   position: 'relative',
        //   width: '100% !important',
        // }
        responsiveScrollMaxHeight: {
          height: "calc(100vh - 250px)",
          maxHeight: "calc(100vh - 250px)",
        },
      },
      MuiToolbar: {
        root: {
          position: "relative",
        },
      },
      MUIDataTableToolbar: {
        root: {
          position: "relative",
          padding: "0px 15px",
          backgroundColor: "#f2f6fa", //'rgba(0,76,151,0.05)',
        },
        titleText: {
          color: "#555",
        },
        icon: {
          color: "#555 !important",
        },
        iconActive: {
          color: "#555 !important",
        },
        left: {
          flex: "0 0 auto !important",
        },
        actions: {
          flex: "1 0 auto !important",
        },
      },
      MUIDataTableSearch: {
        main: {
          position: "absolute",
          top: "0",
          right: "-9px",
          width: "350px !important",
          backgroundColor: "#f2f6fa",
          zIndex: "10",
          textAlign: "right",
          display: "block",
        },
        searchIcon: {
          width: "50px !important",
          color: "#555 !important",
          display: "inline-block",
          textAlign: "center",
          verticalAlign: "top",
        },
        searchText: {
          width: "calc(100% - 120px) !important",
          marginRight: "10px",
          color: "#555 !important",
          display: "inline-block",
          verticalAlign: "top",
        },
        clearIcon: {
          width: "50px !important",
          color: "#555 !important",
          display: "inline-block",
          verticalAlign: "top",
        },
      },
      // MUIDataTableHead: {
      //   main: {
      //     position: "relative",
      //     backgroundColor: mainColor,
      //     color: "#555",
      //     // display: "flex",
      //     // alignItems: "stretch"
      //   },
      //   fixedHeader: {
      //     // position: "relative",
      //     borderBottom: "1px rgba(0,0,0,0.1) solid",
      //     backgroundColor: "#f2f6fa", //'rgba(0,76,151,0.05)',
      //     color: "#555",
      //     padding: "10px 15px",
      //     height: "auto",
      //   },
      // },
      MUIDataTableHeadRow: {
        root: {
          position: "relative",
          backgroundColor: mainColor,
          zIndex: 0,
        },
      },
      MUIDataTableHeadCell: {
        root: {
          fontSize: "10pt",
          fontWeight: "500",
          color: "#555",
          backgroundColor: secondColor,
        },
        fixedHeader: {
          // position: "relative",
          borderBottom: "1px rgba(0,0,0,0.1) solid",
          backgroundColor: "#f2f6fa", //'rgba(0,76,151,0.05)',
          color: "#555",
          padding: "10px 15px",
          height: "auto",
        },
        toolButton: {
          display: "flex",
          height: "auto",
        },
        data: {
          display: "inline-block",
          verticalAlign: "top",
        },
        sortActive: {
          color: "#555",
        },
        sortAction: {
          color: "#555",
          display: "inline-block",
          verticalAlign: "top",
          MuiButtonBase: {
            color: "#555",
            root: {
              color: "#555",
            },
          },
        },
      },
      MUIDataTableBodyCell: {
        root: {
          position: "relative",
          fontSize: "13px",
          padding: "10px 15px",
        },
      },
      MUIDataTableSelectCell: {
        headerCell: {
          backgroundColor: secondColor,
          checkboxRoot: {
            color: "#555",
          },
        },
        checkboxRoot: {
          color: "#555",
        },
      },
      MuiInput: {
        root: {
          top: "5px",
          color: "#555 !important",
        },
        underline: {
          borderBottom: "1px #555 solid !important",
        },
      },
      MuiSelect: {
        root: {
          top: "0",
          color: "#555 !important",
        },
      },
      MuiTablePagination: {
        spacer: {
          flex: "0 0 auto",
        },
      },
      MuiPaper: {
        root: {
          overflowX: "auto !important",
        },
      },
      MuiTableCell: {
        root: {
          borderBottom: "1px solid rgba(224, 224, 224, 1)",
        },
      },
      // MuiIconButton: {
      //   root: {
      //     color: "#fff !important",
      //   }
      // }
    },
  };
};

exports.customTable2 = function () {
  return {
    typography: {
      useNextVariants: true,
    },
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: secondColor,
        },
        paper: {
          boxShadow: "0 0 30px 0 rgba(154,161,171,.15)",
          border: "1px rgba(0,0,0,0.1) solid",
          borderRadius: "5px",
          overflow: "hidden",
        },
      },
      MuiToolbar: {
        root: {
          left: {
            flex: "0 0 auto !important",
          },
          actions: {
            flex: "0 0 auto !important",
          },
        },
      },
      MUIDataTableToolbar: {
        root: {
          backgroundColor: secondColor,
        },
        titleText: {
          color: "#555",
        },
        icon: {
          color: "#555",
        },
      },
      MUIDataTableSearch: {
        searchIcon: {
          color: "#555",
        },
        searchText: {
          color: "#555",
        },
        clearIcon: {
          color: "#555",
        },
      },
      MUIDataTableHead: {
        main: {
          backgroundColor: mainColor,
          color: "#555",
        },
      },
      MUIDataTableHeadRow: {
        root: {
          backgroundColor: mainColor,
        },
      },
      MUIDataTableHeadCell: {
        root: {
          fontSize: "10pt",
          fontWeight: "500",
          color: mainColor,
        },
        fixedHeader: {
          position: "relative",
          backgroundColor: secondColor,
          color: "#555",
          padding: "10px",
          height: "auto",
        },
        toolButton: {
          display: "flex",
          height: "auto",
        },
        data: {
          display: "inline-block",
          verticalAlign: "top",
        },
        sortActive: {
          color: "#555",
        },
        sortAction: {
          color: "#555",
          display: "inline-block",
          verticalAlign: "top",
          MuiButtonBase: {
            color: "#555",
            root: {
              color: "#555",
            },
          },
        },
      },
      MUIDataTableBodyCell: {
        root: {
          fontSize: "10pt",
          padding: "10px",
        },
      },
      MUIDataTableSelectCell: {
        headerCell: {
          backgroundColor: secondColor,
          checkboxRoot: {
            color: "#fff",
          },
        },
        checkboxRoot: {
          color: "#555",
        },
      },
    },
  };
};

exports.customTable3 = function () {
  return {
    typography: {
      useNextVariants: true,
    },
    overrides: {
      MUIDataTable: {
        paper: {
          position: "relative",
          // width: '100% !important',
          boxShadow: "0 0 0 0 rgba(154,161,171,.15)",
          border: "1px rgba(0,0,0,0.1) solid",
          borderRadius: "7.5px",
          overflow: "hidden",
        },
        // responsiveScroll: {
        //   position: 'relative',
        //   width: '100% !important',
        // }
        responsiveScrollMaxHeight: {
          height: "calc(100vh - 250px)",
          maxHeight: "calc(100vh - 250px)",
        },
      },
      MuiToolbar: {
        root: {
          position: "relative",
        },
      },
      MUIDataTableToolbar: {
        root: {
          position: "relative",
          padding: "0px 15px",
          backgroundColor: "#f2f6fa", //'rgba(0,76,151,0.05)',
        },
        titleText: {
          color: "#555",
        },
        icon: {
          color: "#555 !important",
        },
        iconActive: {
          color: "#555 !important",
        },
        left: {
          flex: "0 0 auto !important",
        },
        actions: {
          flex: "1 0 auto !important",
        },
      },
      MUIDataTableSearch: {
        main: {
          position: "absolute",
          top: "0",
          right: "-9px",
          width: "350px !important",
          backgroundColor: "#f2f6fa",
          zIndex: "10",
          textAlign: "right",
          display: "block",
        },
        searchIcon: {
          width: "50px !important",
          color: "#555 !important",
          display: "inline-block",
          textAlign: "center",
          verticalAlign: "top",
        },
        searchText: {
          width: "calc(100% - 120px) !important",
          marginRight: "10px",
          color: "#555 !important",
          display: "inline-block",
          verticalAlign: "top",
        },
        clearIcon: {
          width: "50px !important",
          color: "#555 !important",
          display: "inline-block",
          verticalAlign: "top",
        },
      },
      MUIDataTableHead: {
        main: {
          position: "relative",
          backgroundColor: mainColor,
          color: "#555",
          // display: "flex",
          // alignItems: "stretch"
        },
        fixedHeader: {
          // position: "relative",
          borderBottom: "1px rgba(0,0,0,0.1) solid",
          backgroundColor: "#f2f6fa", //'rgba(0,76,151,0.05)',
          color: "#555",
          padding: "10px 15px",
          height: "auto",
        },
      },
      MUIDataTableHeadRow: {
        root: {
          position: "relative",
          backgroundColor: mainColor,
        },
      },
      MUIDataTableHeadCell: {
        root: {
          fontSize: "10pt",
          fontWeight: "500",
          color: "#555",
          backgroundColor: secondColor,
        },
        fixedHeader: {
          // position: "relative",
          borderBottom: "1px rgba(0,0,0,0.1) solid",
          backgroundColor: "#f2f6fa", //'rgba(0,76,151,0.05)',
          color: "#555",
          padding: "10px 15px",
          height: "auto",
          zIndex: 0,
        },
        toolButton: {
          display: "flex",
          height: "auto",
        },
        data: {
          display: "inline-block",
          verticalAlign: "top",
        },
        sortActive: {
          color: "#555",
        },
        sortAction: {
          color: "#555",
          display: "inline-block",
          verticalAlign: "top",
          MuiButtonBase: {
            color: "#555",
            root: {
              color: "#555",
            },
          },
        },
      },
      MUIDataTableBodyCell: {
        root: {
          position: "relative",
          fontSize: "13px",
          padding: "10px 15px",
        },
      },
      MUIDataTableSelectCell: {
        headerCell: {
          backgroundColor: secondColor,
          checkboxRoot: {
            color: "#555",
          },
        },
        checkboxRoot: {
          color: "#555",
        },
      },
      MuiInput: {
        root: {
          top: "5px",
          color: "#555 !important",
        },
        underline: {
          borderBottom: "1px #555 solid !important",
        },
      },
      MuiSelect: {
        root: {
          top: "0",
          color: "#555 !important",
        },
      },
      // MuiIconButton: {
      //   root: {
      //     color: "#fff !important",
      //   }
      // }
    },
  };
};

exports.customTable4 = function () {
  return {
    typography: {
      useNextVariants: true,
    },
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: secondColor,
        },
        paper: {
          position: "relative",
          // width: '100% !important',
          boxShadow: "0 0 0 0 rgba(154,161,171,.15)",
          border: "1px rgba(0,0,0,0.1) solid",
          borderRadius: "7.5px",
          overflow: "hidden",
        },
        // responsiveScroll: {
        //   position: 'relative',
        //   width: '100% !important',
        // }
        responsiveScrollMaxHeight: {
          height: "calc(100vh - 250px)",
          maxHeight: "calc(100vh - 250px)",
        },
      },
      MuiToolbar: {
        root: {
          position: "relative",
        },
      },
      MUIDataTableToolbar: {
        root: {
          position: "relative",
          padding: "0px 15px",
          backgroundColor: secondColor,
        },
        titleText: {
          color: "#555",
        },
        icon: {
          color: "#555 !important",
        },
        iconActive: {
          color: "#555 !important",
        },
        left: {
          flex: "0 0 auto !important",
        },
        actions: {
          flex: "1 0 auto !important",
        },
      },
      MUIDataTableSearch: {
        main: {
          position: "absolute",
          top: "5px",
          left: "0px",
          width: "350px !important",
          backgroundColor: "#f2f6fa",
          zIndex: "10",
          textAlign: "right",
          display: "block",
        },
        searchIcon: {
          width: "50px !important",
          color: "#555 !important",
          display: "inline-block",
          textAlign: "center",
          verticalAlign: "top",
        },
        searchText: {
          width: "calc(100% - 120px) !important",
          marginRight: "10px",
          color: "#555 !important",
          display: "inline-block",
          verticalAlign: "top",
        },
        clearIcon: {
          width: "50px !important",
          color: "#555 !important",
          display: "inline-block",
          verticalAlign: "top",
        },
      },
      MUIDataTableHead: {
        main: {
          position: "relative",
          backgroundColor: mainColor,
          color: "#555",
          // display: "flex",
          // alignItems: "stretch"
        },
        fixedHeader: {
          position: "relative",
          borderBottom: "1px rgba(0,0,0,0.1) solid",
          backgroundColor: secondColor,
          color: "#555",
          padding: "10px 15px",
          height: "auto",
        },
      },
      MUIDataTableHeadRow: {
        root: {
          position: "relative",
          backgroundColor: mainColor,
        },
      },
      MUIDataTableHeadCell: {
        root: {
          fontSize: "10pt",
          fontWeight: "500",
          color: "#555",
          backgroundColor: secondColor,
        },
        fixedHeader: {
          position: "relative",
          borderBottom: "1px rgba(0,0,0,0.1) solid",
          backgroundColor: secondColor,
          color: "#555",
          padding: "10px 15px",
          height: "auto",
          zIndex: 0,
        },
        toolButton: {
          display: "flex",
          height: "auto",
        },
        data: {
          display: "inline-block",
          verticalAlign: "top",
        },
        sortActive: {
          color: "#555",
        },
        sortAction: {
          color: "#555",
          display: "inline-block",
          verticalAlign: "top",
          MuiButtonBase: {
            color: "#555",
            root: {
              color: "#555",
            },
          },
        },
      },
      MUIDataTableBodyCell: {
        root: {
          position: "relative",
          fontSize: "13px",
          padding: "10px 15px",
        },
      },
      MUIDataTableSelectCell: {
        headerCell: {
          backgroundColor: secondColor,
          checkboxRoot: {
            color: "#555",
          },
        },
        checkboxRoot: {
          color: "#555",
        },
      },
      MuiInput: {
        root: {
          top: "5px",
          color: "#555 !important",
        },
        underline: {
          borderBottom: "1px #555 solid !important",
        },
      },
      MuiSelect: {
        root: {
          top: "0",
          color: "#555 !important",
        },
      },
      // MuiIconButton: {
      //   root: {
      //     color: "#fff !important",
      //   }
      // }
    },
  };
};

exports.customTableNoWrap = function () {
  return {
    typography: {
      useNextVariants: true,
    },
    overrides: {
      MUIDataTable: {
        paper: {
          position: "relative",
          // width: '100% !important',
          boxShadow: "0 0 0 0 rgba(154,161,171,.15)",
          border: "1px rgba(0,0,0,0.1) solid",
          borderRadius: "7.5px",
          overflow: "hidden",
        },
        // responsiveScroll: {
        //   position: 'relative',
        //   width: '100% !important',
        // }
        responsiveScrollMaxHeight: {
          height: "calc(100vh - 250px)",
          maxHeight: "calc(100vh - 250px)",
        },
      },
      MuiToolbar: {
        root: {
          position: "relative",
        },
      },
      MUIDataTableToolbar: {
        root: {
          position: "relative",
          padding: "0px 15px",
          backgroundColor: "#f2f6fa", //'rgba(0,76,151,0.05)',
        },
        titleText: {
          color: "#555",
        },
        icon: {
          color: "#555 !important",
        },
        iconActive: {
          color: "#555 !important",
        },
        left: {
          flex: "0 0 auto !important",
        },
        actions: {
          flex: "1 0 auto !important",
        },
      },
      MUIDataTableSearch: {
        main: {
          position: "absolute",
          top: "0",
          right: "-9px",
          width: "350px !important",
          backgroundColor: "#f2f6fa",
          zIndex: "10",
          textAlign: "right",
          display: "block",
        },
        searchIcon: {
          width: "50px !important",
          color: "#555 !important",
          display: "inline-block",
          textAlign: "center",
          verticalAlign: "top",
        },
        searchText: {
          width: "calc(100% - 120px) !important",
          marginRight: "10px",
          color: "#555 !important",
          display: "inline-block",
          verticalAlign: "top",
        },
        clearIcon: {
          width: "50px !important",
          color: "#555 !important",
          display: "inline-block",
          verticalAlign: "top",
        },
      },
      MUIDataTableHead: {
        main: {
          position: "relative",
          backgroundColor: mainColor,
          color: "#555",
          // display: "flex",
          // alignItems: "stretch"
        },
        fixedHeader: {
          // position: "relative",
          borderBottom: "1px rgba(0,0,0,0.1) solid",
          backgroundColor: "#f2f6fa", //'rgba(0,76,151,0.05)',
          color: "#555",
          padding: "10px 15px",
          height: "auto",
        },
      },
      MUIDataTableHeadRow: {
        root: {
          position: "relative",
          backgroundColor: mainColor,
        },
      },
      MUIDataTableHeadCell: {
        root: {
          fontSize: "10pt",
          fontWeight: "500",
          color: "#555",
          backgroundColor: secondColor,
          whiteSpace: "nowrap",
        },
        fixedHeader: {
          // position: "relative",
          borderBottom: "1px rgba(0,0,0,0.1) solid",
          backgroundColor: "#f2f6fa", //'rgba(0,76,151,0.05)',
          color: "#555",
          padding: "10px 15px",
          height: "auto",
        },
        toolButton: {
          display: "flex",
          height: "auto",
        },
        data: {
          display: "inline-block",
          verticalAlign: "top",
        },
        sortActive: {
          color: "#555",
        },
        sortAction: {
          color: "#555",
          display: "inline-block",
          verticalAlign: "top",
          MuiButtonBase: {
            color: "#555",
            root: {
              color: "#555",
            },
          },
        },
      },
      MUIDataTableBodyCell: {
        root: {
          position: "relative",
          fontSize: "13px",
          padding: "10px 15px",
          whiteSpace: "nowrap",
        },
      },
      MUIDataTableSelectCell: {
        headerCell: {
          backgroundColor: secondColor,
          checkboxRoot: {
            color: "#555",
          },
        },
        checkboxRoot: {
          color: "#555",
        },
      },
      MuiInput: {
        root: {
          top: "5px",
          color: "#555 !important",
        },
        underline: {
          borderBottom: "1px #555 solid !important",
        },
      },
      MuiSelect: {
        root: {
          top: "0",
          color: "#555 !important",
        },
      },
      // MuiIconButton: {
      //   root: {
      //     color: "#fff !important",
      //   }
      // }
    },
  };
};

exports.customOptions = function (customButton) {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: "multiselect",
    filter: false,
    sort: false,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    customToolbar: customButton ? customButton : null,
  };
};

exports.customOptions2 = function () {
  return {
    selectableRows: true,
    filterType: "dropdown",
    filter: false,
    sort: false,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
  };
};

exports.customOptions3 = function () {
  return {
    selectableRows: true,
    filterType: "dropdown",
    filter: false,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    sort: true,
    elevation: 5,
  };
};

exports.customOptions4 = function () {
  return {
    selectableRows: false,
    filter: false,
    // responsive: 'scrollMaxHeight',
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    sort: true,
    search: false,
    viewColumns: false,
    elevation: 5,
  };
};

exports.customOptions5 = function () {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: false,
    filter: false,
    sort: false,
    viewColumns: false,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
  };
};

exports.customOptions6 = function () {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: false,
    filter: false,
    sort: true,
    // viewColumns:false,
    overflowX: "auto",
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 30],
    print: false,
    download: false,
    elevation: 5,
    // search:false
  };
};

exports.customOptions7 = function () {
  return {
    selectableRows: true,
    filterType: "dropdown",
    filter: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
  };
};

exports.customOptions8 = function () {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: false,
    filter: false,
    sort: true,
    // viewColumns:false,
    overflowX: "auto",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: true,
    elevation: 5,
    search: false,
  };
};

exports.customOptions9 = function (customButton) {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: "multiselect",
    filter: false,
    sort: true,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    customToolbar: customButton ? customButton : null,
  };
};

exports.customOptions10 = function () {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: "multiselect",
    filter: false,
    sort: true,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: true,
    download: true,
    elevation: 5,
  };
};

exports.customOptions11 = function (customButton) {
  return {
    // selectableRows: false,
    viewColumns: false,
    search: false,
    selectableRows: "multiple",
    filterType: "multiselect",
    filter: false,
    sort: false,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    customToolbar: customButton ? customButton : null,
  };
};

//akbar
exports.customOptions12 = function (customButton) {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: "multiselect",
    filter: false,
    sort: false,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    customToolbar: customButton ? customButton : null,
    search: false,
  };
};

exports.customOptions13 = function () {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: false,
    filter: false,
    sort: true,
    // viewColumns:false,
    overflowX: "auto",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    search: false,
  };
};

exports.customOptions14 = function () {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: false,
    filter: false,
    sort: true,
    viewColumns: false,
    overflowX: "auto",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    search: false,
  };
};

//way
exports.customOptions15 = function (customButton) {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: "multiselect",
    filter: false,
    sort: false,
    viewColumns: false,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    customToolbar: customButton ? customButton : null,
    search: false,
  };
};

exports.customOptions16 = function () {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: false,
    filter: false,
    sort: true,
    viewColumns: false,
    overflowX: "auto",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    search: false,
  };
};

exports.customOptions17 = function (customButton) {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: false,
    filter: false,
    sort: true,
    responsive: "scrollMaxHeight",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    customToolbar: customButton ? customButton : null,
  };
};

exports.customOptions18 = function () {
  return {
    // selectableRows: false,
    selectableRows: "none",
    filterType: false,
    filter: false,
    sort: false,
    // viewColumns:false,
    overflowX: "auto",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    print: false,
    download: false,
    elevation: 5,
    // search:false
  };
};

exports.defaultTableChange = function (onChangePage, onChangeRowsPerPage) {
  return {
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          if (typeof onChangePage === "function") {
            onChangePage(tableState);
          }
          break;
        case "changeRowsPerPage":
          if (typeof onChangeRowsPerPage === "function") {
            onChangeRowsPerPage(tableState);
          }
          break;
        default:
          break;
      }
    },
  };
};

let lastSort = { name: null, direction: null };

exports.defaultTableChangePromo = function (onSort, onChangePage, onChangeRowsPerPage) {
  return {
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          if (typeof onChangePage === "function") onChangePage(tableState);
          break;

        case "changeRowsPerPage":
          if (typeof onChangeRowsPerPage === "function") onChangeRowsPerPage(tableState);
          break;

        case "sort":
          if (typeof onSort === "function") {
            let fieldName = null;

            if (tableState.activeColumn !== null) {
              const colIndex = tableState.activeColumn;
              const colDef = tableState.columns[colIndex];

              if (colDef) {
                fieldName = colDef.name;

                if (colDef.name === "dataVariant") {
                  if (colIndex === 1) fieldName = "kodeVariant";
                  if (colIndex === 2) fieldName = "namaVariant";
                }
                if (colDef.name === "dataWarna") {
                  if (colIndex === 4) fieldName = "kodeWarna";
                  if (colIndex === 5) fieldName = "namaWarnaKomersil";
                }
              }
            }

            let direction = "asc";
            if (lastSort.name === fieldName && lastSort.direction === "asc") {
              direction = "desc";
            }

            lastSort = { name: fieldName, direction };

            const sortOrder = { ...lastSort };

            console.log("SORT ORDER:", sortOrder);
            onSort(sortOrder);
          }
          break;

        default:
          break;
      }
    },
  };
};

exports.defaultTableChange1 = function (
  onChangePage,
  onChangeRowsPerPage,
  onRowsSelected,
  onRowClick
) {
  return {
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          if (typeof onChangePage === "function") {
            onChangePage(tableState);
          }
          break;
        case "changeRowsPerPage":
          if (typeof onChangeRowsPerPage === "function") {
            onChangeRowsPerPage(tableState);
          }
          break;
        case "rowsSelect":
          if (typeof onRowsSelected === "function") {
            const selectedDataIndex = tableState.selectedRows.data.map(
              (state) => state.dataIndex
            );
            onRowsSelected(selectedDataIndex);
          }
          break;
        default:
          break;
      }
    },

    onRowClick: (rowData, rowMeta) => {
      if (typeof onRowClick === "function") {
        onRowClick(rowData, rowMeta);
      }
    },
  };
};
